import instance from "../axios/axios.config";

export const getAllCredentialsApi = async (getAllDetails) => {
    try {
        const response = await instance.credential.get(`credentials?all=${getAllDetails}`)
        return response?.result || []
    } catch (error) {
        console.error(error)
    }
}

export const createCredentialApi = async (payload) => {
    try {
        const response = await instance.credential.post('credentials', { ...payload })
        return response?.result
    } catch (error) {
        console.error(error)
    }
}

export const updateCredentialApi = async (id, payload) => {
    try {
        const response = await instance.credential.put(`credentials/${id}`, payload)
        return response
    } catch (error) {
        console.error(error)
    }
}

export const deleteCredentialApi = async (id) => {
    try {
        const response = await instance.credential.delete(`credentials/${id}`)
        return response
    } catch (error) {
        console.error(error)
    }
}
